import { fetchAPI } from "./baseApi";

export async function getOpenSourceAdmin() {
  return fetchAPI("/open-source/admin", { method: "GET" });
}

export async function createOpenSource(data) {
  return fetchAPI("/open-source/admin", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateOpenSource(id, data) {
  return fetchAPI(`/open-source/admin/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deleteOpenSource(id) {
  return fetchAPI(`/open-source/admin/${id}`, { method: "DELETE" });
}
